import { registerMutation } from 'data-fetching-client';
import { createPurchaseOrderRpc } from '../../__generated__/chirp/com/hubspot/buying/rpc/BuyingRpc';
import { rpcClient } from '../client';
export const createPurchaseOrder = request => {
  return rpcClient.call(createPurchaseOrderRpc, {
    request,
    timeout: 30000
  });
};
export const PURCHASE_ORDER_GENERATION_MUTATION = registerMutation({
  fieldName: 'purchaseOrderGeneration',
  args: ['commitmentTerm', 'currencyCode', 'paymentTerm', 'products'],
  fetcher: createPurchaseOrder
});